export default __webpack_public_path__ + "e58b7528988b7eb5332cb9036b4a8763.svg";